export const SYNC_PRODUCTS_START = 'SYNC_PRODUCTS_START';
export const syncProductsStart = (sellerFillProviderId, asnGuid, advancedShippingNotice, onStart, onSuccess, onError) => ({
  type: SYNC_PRODUCTS_START,
  sellerFillProviderId,
  asnGuid,
  advancedShippingNotice,
  onStart,
  onSuccess,
  onError,
});
